import type { Route } from '@application/types';
import type { NavigateToRouteOptions } from '@application/utils';
import type { MouseEventHandler } from 'react';

export interface NotificationRouteOptions {
  route: Route;
  options?: NavigateToRouteOptions;
}

export interface MtNotificationItemData {
  id: number;
  content: string;
  date?: string;
  success: boolean;
  routeOptions: NotificationRouteOptions;
}

export interface MtNotificationsPanelData {
  newNotificationsCount: number | undefined;
  items?: MtNotificationItemData[];
  isOpen: boolean;
  onBellClick: MouseEventHandler;
  onMarkAllAsReadClick: () => void;
  onItemClick: (notification: MtNotificationItemData) => void;
  onClosePanel: () => void;
  onLoadMore: () => void;
  canLoadMore: boolean;
  isLoading: boolean;
}

export interface MtNotificationsPanelProps extends MtNotificationsPanelData {}
